export enum AppRoute {
    FALLBACK = '*',
    ROOT = '/',
    PLAYGROUND = '/playground',
    MAGIC_LINK = '/magic-link',
    DEMO_LOGIN = '/demo-login',
    CAREVIEW = '/careview',
    RECALL = '/recall',
    EXTRACTION = '/extraction',
    CONNECT = '/connect',
    ASSISTANT_FORM = '/connect/assistants/:assistantId',
}
